module.exports = __webpack_public_path__ + "static/media/bmw.41f58531.png";